import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from 'react';
import FullScreenLoader from '../components/Layout/FullScreenLoader';
import { useAppDispatch } from '../redux/store';
import { LocalStoreKey, LocalStoreManager } from '../utils/LocalStoreManager';


type IAuthMiddleware = {
  children: React.ReactElement;
};

/**
  @description: Check if token in LocalStore has a valid expiration date. If it is, set user in redux store
 */

const AuthMiddleware: React.FC<IAuthMiddleware> = ({ children }) => {
  const { LOCALSTORE_TOKEN } = LocalStoreKey
  const token = LocalStoreManager.get(LOCALSTORE_TOKEN);
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const { exp } = decoded as any;
      const now = new Date().getTime() / 1000;

      if (exp > now) {
        dispatch({ type: 'userSlice/setUser', payload: decoded });
      }
      else {
        LocalStoreManager.remove(LOCALSTORE_TOKEN)
      }
    }
    setIsLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <FullScreenLoader />;
  }

  return children;
};

export default AuthMiddleware;
